export const adminEl = {
    'admin.language.selector': 'Γλώσσα περιβάλλοντος',
    'admin.language.el': 'Ελληνικά',
    'admin.language.en': 'English',
    'nav.overview': 'Επισκόπηση',
    'nav.sites': 'Ιστοσελίδες',
    'nav.knowledge': 'Βάση γνώσης',
    'nav.conversations': 'Συνομιλίες',
    'nav.contacts': 'Επαφές',
    'nav.usage': 'Χρήση & χρεώσεις',
    'nav.members': 'Μέλη',
    'nav.audit': 'Audit',
    'nav.settings': 'Ρυθμίσεις',
    'nav.platform': 'Επισκόπηση',
    'nav.tenants': 'Πελάτες',
    'nav.plans': 'Πακέτα',
    'nav.billing': 'Τιμολόγηση',
    'nav.costs': 'Κόστος OpenAI',
    'nav.platformSettings': 'Ρυθμίσεις πλατφόρμας',
    'nav.setup': 'Οδηγός εκκίνησης',
    'nav.system': 'Σύστημα',
    'nav.systemStatus': 'Κατάσταση',
    'shell.platformManage': 'Διαχείριση πλατφόρμας',
    'shell.clientDashboard': 'Πίνακας πελάτη',
    'shell.platformSection': 'Πλατφόρμα',
    'shell.organization': 'Οργανισμός',
    'shell.client': 'Πελάτης',
    'shell.systemSection': 'Σύστημα',
    'shell.pickTenant': 'Επιλέξτε πελάτη από το επάνω μενού για να δείτε τα δεδομένα του.',
    'shell.tenantLabel': 'Πελάτης',
    'shell.noneTenant': '— Κανένας —',
    'shell.suspended': 'σε αναστολή',
    'shell.platformAdmin': 'Διαχειριστής πλατφόρμας',
    'shell.tenantAdmin': 'Διαχειριστής',
    'shell.viewer': 'Προβολή μόνο',
    'shell.logout': 'Αποσύνδεση',
    'shell.login': 'Σύνδεση',
    'shell.loadingSession': 'Φόρτωση συνεδρίας…',
    'shell.version': 'Έκδοση {version}',
    'shell.privateAuth': 'Ιδιωτικό περιβάλλον διαχείρισης. Η πρόσβαση δίνεται μόνο με πρόσκληση.',
    'shell.mainNav': 'Κύρια πλοήγηση',
    'shell.group.platform': 'Πλατφόρμα',
    'shell.group.organization': 'Οργανισμός',
    'shell.group.system': 'Σύστημα',
    'shell.noAccess.title': 'Ο λογαριασμός δεν ανήκει σε κανέναν πελάτη.',
    'shell.noAccess.hint': 'Ζητήστε πρόσκληση από τον διαχειριστή του οργανισμού σας.',
    'shell.notFound': 'Η σελίδα δεν βρέθηκε.',
    'auth.login.title': 'Σύνδεση στο {product}',
    'auth.login.submit': 'Σύνδεση',
    'auth.login.submitting': 'Σύνδεση…',
    'auth.email': 'Email',
    'auth.password': 'Κωδικός',
    'auth.passwordPlaceholder': 'Εισάγετε τον κωδικό σας',
    'auth.showPassword': 'Προβολή κωδικού',
    'auth.hidePassword': 'Απόκρυψη κωδικού',
    'auth.forgot': 'Ξέχασα τον κωδικό',
    'auth.invalidCredentials': 'Τα στοιχεία σύνδεσης δεν έγιναν δεκτά.',
    'auth.changePassword.failed': 'Ο κωδικός δεν άλλαξε. Ελέγξτε τον τρέχοντα κωδικό και τους κανόνες του νέου.',
    'auth.secureAccess': 'Ασφαλής πρόσβαση',
    'common.save': 'Αποθήκευση',
    'common.saving': 'Αποθήκευση…',
    'common.cancel': 'Άκυρο',
    'common.close': 'Κλείσιμο',
    'common.retry': 'Επανάληψη',
    'common.loading': 'Φόρτωση…',
    'common.error': 'Κάτι πήγε στραβά.',
    'common.back': 'Πίσω',
    'common.continue': 'Συνέχεια',
    'common.skip': 'Παράλειψη',
    'common.later': 'Αργότερα',
    'common.create': 'Δημιουργία',
    'common.delete': 'Διαγραφή',
    'common.activate': 'Ενεργοποίηση',
    'common.reject': 'Απόρριψη',
    'common.search': 'Αναζήτηση',
    'common.all': 'Όλα',
    'common.yes': 'Ναι',
    'common.no': 'Όχι',
    'common.actions': 'Ενέργειες',
    'setup.progress': 'Πρόοδος {current} από {total}',
    'setup.welcome.title': 'Ας ετοιμάσουμε την πλατφόρμα',
    'setup.welcome.body': 'Ο οδηγός κάνει τις ρυθμίσεις που χρειάζονται για να απαντάει το chatbot σε μία ιστοσελίδα.',
    'setup.step.welcome': 'Καλωσόρισμα',
    'setup.step.brand': 'Εμφάνιση',
    'setup.step.ai': 'Πάροχος AI',
    'setup.step.mail': 'Email',
    'setup.step.customer': 'Πελάτης',
    'setup.step.site': 'Ιστοσελίδα',
    'setup.step.knowledge': 'Γνώση',
    'setup.step.connect': 'WordPress',
    'setup.step.invite': 'Πρόσκληση',
    'setup.step.done': 'Έτοιμο',
    'setup.connect.steps': '1) Κατεβάστε το plugin. 2) Επικολλήστε το API URL και τον κωδικό. 3) Επιλέξτε σελίδες και συγχρονίστε.',
    'setup.validation.required': 'Συμπληρώστε τα υποχρεωτικά πεδία πριν συνεχίσετε.',
    'knowledge.title': 'Βάση γνώσης',
    'knowledge.status.draft': 'Πρόχειρο',
    'knowledge.status.processing': 'Σε επεξεργασία',
    'knowledge.status.active': 'Ενεργό',
    'knowledge.status.failed': 'Αποτυχία',
    'knowledge.status.inactive': 'Ανενεργό',
    'knowledge.retry': 'Επανάληψη επεξεργασίας',
    'knowledge.errorReason': 'Αιτία',
    'knowledge.ingestionProgress': 'Επεξεργασία περιεχομένου…',
    'knowledge.needsReview': 'Χρειάζονται έλεγχο',
    'knowledge.syncRequested': 'Το αίτημα καταχωρήθηκε. Το πρόσθετο θα στείλει τις επιλεγμένες σελίδες.',
    'sync.lastRun': 'Τελευταίος συγχρονισμός',
    'sync.nextScheduled': 'Επόμενος προγραμματισμένος',
    'sync.progress': 'Πρόοδος συγχρονισμού',
    'sync.failedItems': 'Αποτυχημένα στοιχεία',
    'sync.retryItem': 'Επανάληψη',
    'sync.skipItem': 'Παράβλεψη',
    'sync.request': 'Αίτημα συγχρονισμού',
    'sync.noRuns': 'Δεν υπάρχει συγχρονισμός ακόμη.',
    'dashboard.quotaAlert80': 'Έχετε φτάσει το 80% του μηνιαίου ορίου απαντήσεων.',
    'dashboard.quotaAlert100': 'Το μηνιαίο όριο απαντήσεων έχει εξαντληθεί.',
    'dashboard.provider': 'Πάροχος AI',
    'dashboard.provider.mock': 'Mock',
    'dashboard.provider.openai': 'OpenAI',
    'dashboard.provider.mockHint': 'Οι απαντήσεις είναι τοπικές· δεν υπάρχει χρέωση παρόχου.',
    'dashboard.queue': 'Ουρά εργασιών',
    'dashboard.syncHealth': 'Υγεία συγχρονισμού',
    'dashboard.healthy': 'Φυσιολογικό',
    'dashboard.degraded': 'Προσοχή',
    'billing.status.open': 'Απλήρωτο',
    'billing.status.partial': 'Μερική πληρωμή',
    'billing.status.overdue': 'Εκπρόθεσμο',
    'billing.status.paid': 'Πληρωμένο',
    'billing.status.void': 'Ακυρωμένο',
    'billing.balance': 'Υπόλοιπο',
    'billing.paymentHistory': 'Ιστορικό πληρωμών',
    'billing.downloadLater': 'Η λήψη PDF τιμολογίου θα προστεθεί σε επόμενη έκδοση.',
    'widget.offline.title': 'Η υπηρεσία δεν είναι διαθέσιμη',
    'widget.offline.retry': 'Επανάληψη σύνδεσης',
};
//# sourceMappingURL=admin-el.js.map